import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { NotificationProxyService } from './notifications-proxy.service';
import { WebApiResponse } from '../api/models/api-model';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	constructor(
		private notificationProxyService: NotificationProxyService
	) { }

	public registerDevice(fcmToken: string): Observable<WebApiResponse<void>> {
		return this.notificationProxyService.registerDevice(fcmToken);
	}

	public unregisterDevice(): Observable<WebApiResponse<void>> {
		return this.notificationProxyService.unregisterDevice();
	}
}
